/**
 * The Kanyami icon size scale. Icons are always requested by token, never by
 * raw pixels, so every surface across every product picks from the same ramp:
 * inline metadata (xs/s), actions and menus (m/l — m is the default), and
 * hero/empty states (xl/xxl). All glyphs are drawn on a 24x24 grid, so l is
 * the native 1:1 size.
 */export const ICON_SIZE_PX=Object.freeze({xxxs:10,xxs:12,xs:14,s:16,m:20,l:24,xl:32,xxl:48});